export const data = {
    labels: [''],
    datasets: [
        {
            label: 'Tagesleistung',
            fill: true,
            tension: 0.4,
            borderWidth: 2.5,
            borderColor: 'rgba(34, 197, 94, 1)',
            backgroundColor: 'rgba(34, 197, 94, 0.15)',
            pointRadius: 0,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: 'rgba(34, 197, 94, 1)',
            pointHoverBorderColor: '#ffffff',
            pointHoverBorderWidth: 2,
            data: [0]
        }
    ]
};
